import { render, staticRenderFns } from "./AnswerForm.vue?vue&type=template&id=9de2a502&"
import script from "./AnswerForm.vue?vue&type=script&lang=js&"
export * from "./AnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./AnswerForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AnswerForm.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VForm,
  VIcon,
  VLayout,
  VTextarea,
})
